// extracted by mini-css-extract-plugin
export default {"gr":"style_gr__nGjXq","text-gradient-bg":"style_text-gradient-bg__yCkNX"};